import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NewTitle from "../../extra/Title";
import StatsCards from "../../extra/StatsCards";
import AdsCoinRewardSetting from "./AdsCoinRewardSetting";
import DailyRewardSetting from "./DailyRewardSetting";
import RefralBonus from "./RefralBonus";
import EngagementSetting from "./EngagementSetting";
import LoginRewardSetting from "./LoginRewardSetting";
import { getRewardStatsData } from "../../store/setting/setting.action";
import {
  IconAd,
  IconCoin,
  IconCoins,
  IconCalendarCheck,
  IconCalendarEvent,
  IconUsers,
  IconUserPlus,
  IconClick,
  IconTrophy,
  IconLogin,
  IconAward,
} from "@tabler/icons-react";

const ManageReward = () => {
  const dispatch = useDispatch();
  const [multiButtonSelect, setMultiButtonSelect] = useState("Ads Coin Reward");
  const { rewardStatsData } = useSelector((state) => state.setting);

  useEffect(() => {
    dispatch(getRewardStatsData());
  }, [dispatch]);

  const statsCards = [
    {
      title: "Total Ad Rewards",
      count: rewardStatsData?.totalAdReward,
      Icon: IconAd,
    },
    {
      title: "Coins From Ads",
      count: rewardStatsData?.totalCoinsEarnedFromAds,
      Icon: IconCoins,
    },
    {
      title: "Coins From Ads Today",
      count: rewardStatsData?.totalCoinsEarnedFromAdsToday,
      Icon: IconCoin,
    },
    {
      title: "Total Daily Check-In",
      count: rewardStatsData?.totalDailyCheckins,
      Icon: IconCalendarCheck,
    },
    {
      title: "Check-In Coins",
      count: rewardStatsData?.totalCoinsEarnedFromDailyCheckin,
      Icon: IconCoins,
    },
    {
      title: "Check-In Coins Today",
      count: rewardStatsData?.totalCoinsEarnedFromDailyCheckinToday,
      Icon: IconCalendarEvent,
    },
    {
      title: "Total Referrals",
      count: rewardStatsData?.totalReferrals,
      Icon: IconUsers,
    },
    {
      title: "Referral Coins",
      count: rewardStatsData?.totalCoinsEarnedFromReferral,
      Icon: IconUserPlus,
    },
    {
      title: "Engagement Rewards",
      count: rewardStatsData?.totalEngagementRewards,
      Icon: IconTrophy,
    },
    {
      title: "Engagement Coins",
      count: rewardStatsData?.totalCoinsEarnedFromEngagement,
      Icon: IconClick,
    },
    {
      title: "Login Rewards",
      count: rewardStatsData?.totalLoginRewards,
      Icon: IconAward,
    },
    {
      title: "Login Coins",
      count: rewardStatsData?.totalCoinsEarnedFromLogin,
      Icon: IconLogin,
    },
  ];

  return (
    <div className="userPage">
      <div>
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={false}
            setMultiButtonSelect={setMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={[
              "Ads Coin Reward",
              "Daily CheckIn Reward",
              "Referral Reward",
              "Engagement Reward",
              "Login Reward",
            ]}
          />
        </div>
        <StatsCards cards={statsCards} />
        {multiButtonSelect == "Ads Coin Reward" && <AdsCoinRewardSetting />}
        {multiButtonSelect == "Daily CheckIn Reward" && <DailyRewardSetting />}
        {multiButtonSelect == "Referral Reward" && <RefralBonus />}
        {multiButtonSelect == "Engagement Reward" && <EngagementSetting />}
        {multiButtonSelect == "Login Reward" && <LoginRewardSetting />}
      </div>
    </div>
  );
};

export default ManageReward;
